//Reducer Actions -
export const NEXT_STAGE_UPLVLRNW = 'NEXT_STAGE_UPLVLRNW';
export const PREVIOUS_STAGE = 'PREVIOUS_STAGE';
export const SUBMIT_FINAL = 'SUBMIT_FINAL';
export const NEXT_BUTTON_UPDATE_UPLVLRNW = 'NEXT_BUTTON_UPDATE_UPLVLRNW';
export const SET_IS_COC_VALIDATION_REGION = 'SET_IS_COC_VALIDATION_REGION';
export const SAVE_AND_EXIT_UPDATE = 'SAVE_AND_EXIT_UPDATE';

// Links
export const RESELLER_GUIDE = 'http://partnerdownload.adobe.com/p/NA_Reseller_Program_Guide_UE.pdf';
export const ADOBE_CHANNEL_PARTNER = 'https://partners.adobe.com/channelpartners/home.html';
export const CONTACT_HELPDESK = 'http://www.adobe.com/support/reseller/';
export const RESELLER_PROG_TANDC = 'http://partnerdownload.adobe.com/p/Americas_Reseller_Program_TandC_UE.pdf';